/** Custom event posle prihvatanja/odbijanja moderacije (bez feature zavisnosti). */
export const MODERATOR_ASSIGNMENT_CHANGED_EVENT = 'moderator-assignment-changed';

/**
 * @param {string|number|null|undefined} obligationId
 */
export function dispatchModeratorAssignmentChanged(obligationId) {
  const id =
    obligationId != null && String(obligationId).trim() !== ''
      ? String(obligationId)
      : null;

  window.dispatchEvent(
    new CustomEvent(MODERATOR_ASSIGNMENT_CHANGED_EVENT, {
      detail: { obligationId: id },
    }),
  );
}
